import React, { Component } from 'react';
import { connect } from 'react-redux';
import Heading from '../components/Heading';
import actions from '../redux/actions';
// import actionTypes from '../redux/actionTypes';
import Select from '../components/Select';

class DevExample extends Component {
  constructor(...args) {
    super(...args);
    this.state = { period: 'monthly' };
  }

  handleContent(key, value) {
    this.setState({ [key]: value });
  }

  render() {
    return (
      <div className="not-found">
        <Heading text="Example" />

        <Select
          className="select-mini"
          value={this.state.period}
          onChange={(e) => this.handleContent('period', e.target.value)}
        >
          <option value="">select</option>
          <option>monthly</option>
          <option>quarterly</option>
          <option>semi-annually</option>
          <option>annually</option>
        </Select>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  clientToken: state.payment.clientToken,
  status: state.payment.status,
});

const mapDispatchToProps = (dispatch) => ({
  getClientToken: () => {
    dispatch(actions.clientToken());
  },
  checkout: (options) => {
    dispatch(actions.checkout(options));
  },
  subscribe: (options) => {
    dispatch(actions.subscribe(options));
  },
  cancelSubscribe: (options) => {
    dispatch(actions.cancelSubscribe(options));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DevExample);



// WEBPACK FOOTER //
// src/pages/DevExample.jsx